import { useQuery } from '@tanstack/react-query'
import type { HealthResponse, ReadyResponse } from '@tex/finance-shared'
import { apiGet } from './api'

export function useHealth() {
  return useQuery({ queryKey: ['health'], queryFn: () => apiGet<HealthResponse>('/api/healthz') })
}

export function useReadiness() {
  return useQuery({ queryKey: ['ready'], queryFn: () => apiGet<ReadyResponse>('/api/readyz'), retry: false })
}
